import zhMessages from "../locales/zh_Hans.json";
import { LangConfig } from "../model";

export const ZhLang: LangConfig = {
  messages: {
    ...zhMessages,
  },
  locale: "zh-Hans",
};
